import { Component } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-branding',
  imports: [RouterModule],
  template: `
 <div class="dlogo">
   <a  class="logodark">
      <img
        src="./assets/images/logos/logo-dark.svg"
        class="align-middle m-2" style="width:212px !Important;"
        alt="logo" class="logo"
      />
    </a>

    <a [routerLink]="['/']" class="logolight">
      <img
        src="./assets/images/logos/logo-light.svg"
        class="align-middle m-2" class="logo"
        alt="logo"
      />
    </a>

</div>

 <a [routerLink]="['/']" class="logomini">
  <img
        src="./assets/images/logos/logomini-dark.png"
        class="align-middle m-2" class="logo"
        alt="logo"
      />
</a>
  `,
})
export class BrandingComponent {
  options = this.settings.getOptions();
  constructor(private settings: CoreService) {}
}
